import { usePermissions } from './usePermissions';
import { useAuth } from '../context/AuthContext';

/**
 * Hook خاص بالتحقق من صلاحيات قوالب السندات
 * يستخدم للتحقق من صلاحيات المستخدم للوصول إلى قوالب السندات (سندات القبض، الصرف، القيود)
 */
export const useVoucherTemplatePermissions = () => {
  const { hasPermission } = usePermissions();
  const { user } = useAuth();

  /**
   * التحقق من صلاحية الوصول لصفحة قوالب السندات
   * @returns {boolean} هل لدى المستخدم صلاحية الوصول للصفحة
   */
  const canAccessVoucherTemplates = (): boolean => {
    // إذا كان المستخدم مسؤولاً (admin)، أعط صلاحية كاملة
    if (user?.role === 'admin') {
      return true;
    }

    // التحقق من صلاحية الوصول لصفحة قوالب السندات
    return hasPermission('finance', 'voucher-templates', 'view_page');
  };

  /**
   * التحقق من صلاحية إنشاء قالب سند جديد
   * @returns {boolean} هل لدى المستخدم صلاحية إنشاء قالب
   */
  const canCreateVoucherTemplate = (): boolean => {
    // إذا كان المستخدم مسؤولاً (admin)، أعط صلاحية كاملة
    if (user?.role === 'admin') {
      return true;
    }

    // التحقق من صلاحية إنشاء قالب سند
    return hasPermission('finance', 'voucher-templates', 'create');
  };

  /**
   * التحقق من صلاحية تعديل قالب سند
   * @returns {boolean} هل لدى المستخدم صلاحية تعديل قالب
   */
  const canEditVoucherTemplate = (): boolean => {
    // إذا كان المستخدم مسؤولاً (admin)، أعط صلاحية كاملة
    if (user?.role === 'admin') {
      return true;
    }

    // التحقق من صلاحية تعديل قالب سند
    return hasPermission('finance', 'voucher-templates', 'edit');
  };

  /**
   * التحقق من صلاحية حذف قالب سند
   * @returns {boolean} هل لدى المستخدم صلاحية حذف قالب
   */
  const canDeleteVoucherTemplate = (): boolean => {
    // إذا كان المستخدم مسؤولاً (admin)، أعط صلاحية كاملة
    if (user?.role === 'admin') {
      return true;
    }

    // التحقق من صلاحية حذف قالب سند
    return hasPermission('finance', 'voucher-templates', 'delete');
  };

  return {
    canAccessVoucherTemplates,
    canCreateVoucherTemplate,
    canEditVoucherTemplate,
    canDeleteVoucherTemplate
  };
};